<template>
  <section class="group-container">
    <menu-group-header
      :menu-group="menuGroup"
      :selected-specs="selectedSpecs"
      :selected-files="selectedFiles"
      :open="open"
      :show-toggle="showToggle"
      @toggle="toggleGroup"
    />
    <transition-height>
      <section
        class="menu-group-holder"
        :class="{ 'full-height': !showToggle }"
        v-if="open"
      >
        <product-description
          v-if="menuGroup.description"
          :description="menuGroup.description"
        ></product-description>
        <div
          v-for="(optionGroup, index) in menuGroup.optionGroups"
          :key="index"
          class="menu-block"
        >
          <hr v-if="index > 0" />

          <option-group-header :title="optionGroup.title" />

          <div v-if="optionGroup.name === 'opmerking'" class="comment">
            <textarea
              placeholder="Type hier uw opmerking"
              class="grey-field"
              :value="note"
              @input="setNote(menuGroup, optionGroup.name, $event.target.value)"
              :style="[index > 1 ? { 'margin-top': '15px' } : {}]"
            ></textarea>
          </div>
          <DatePicker
            v-if="
              optionGroup.name === 'datePicker' &&
              !hideCheck(optionGroup.options[0], selectedFiles)
            "
            :menu-group="menuGroup"
            :title="optionGroup.options[0].title"
            :selected-date="
              selectedSpecs.find(
                (spec) => spec.optionGroupName === 'datePicker'
              )?.optionName
            "
            @date-selected="
              setSpec(menuGroup, optionGroup.name, $event.name, $event)
            "
          />
          <ul
            v-else-if="optionGroup.options"
            class="menu-options"
            :class="{ standalone: standalone }"
          >
            <template
              v-for="(option, index) in optionGroup.options"
              :key="index"
            >
              <li v-if="option && !hideCheck(option, selectedFiles)">
                <spec-button
                  :id="option.name"
                  :title="optionTitle(menuGroup, optionGroup.name, option)"
                  :selected="
                    optionSelectedCheck(
                      menuGroup,
                      optionGroup.name,
                      option,
                      selectedFiles
                    )
                  "
                  @action="
                    setSpec(menuGroup, optionGroup.name, option.name, option)
                  "
                  :inactive="
                    disabledCheck(
                      option,
                      selectedFiles,
                      menuGroup,
                      optionGroup.name
                    )
                  "
                  :has-sub="hasSub(option.subOptions)"
                >
                </spec-button>

                <spec-sub-menu
                  v-if="option && option.subOptions"
                  :show="showSub.indexOf(option.name) > -1"
                  :submenu="option.subOptions"
                  @close="hideSub"
                >
                  <template #default="{ spec }">
                    <spec-button
                      v-if="spec && !hideCheck(spec, selectedFiles)"
                      :title="spec.title"
                      :inactive="
                        disabledCheck(
                          spec,
                          selectedFiles,
                          menuGroup,
                          optionGroup.name
                        )
                      "
                      @action="
                        setSpec(menuGroup, optionGroup.name, spec.name, {
                          title: spec.title,
                          priceKey: spec.priceKey,
                          priceValue: spec.priceValue
                        })
                      "
                      :selected="
                        optionSelectedCheck(
                          menuGroup,
                          optionGroup.name,
                          spec,
                          selectedFiles
                        )
                      "
                    ></spec-button>
                  </template>
                </spec-sub-menu>
              </li>
            </template>
          </ul>

          <option-group-description
            v-if="optionGroup.description"
            :description="optionGroup.description"
          />
        </div>
      </section>
    </transition-height>
  </section>
</template>

<script>
import SpecButton from '@/components/ui/SpecButton'
import SpecSubMenu from '@/components/ui/SpecSubMenu'
import ProductOrderMixin from '@/features/productOrder/ProductOrderMixin'
import ProductDescription from './ProductDescription.vue'
import TransitionHeight from '../../../../components/TransitionHeight.vue'
import DatePicker from './DatePicker.vue'
import MenuGroupHeader from './MenuGroupHeader.vue'
import OptionGroupHeader from './OptionGroupHeader.vue'
import OptionGroupDescription from './OptionGroupDescription.vue'

export default {
  props: [
    'menuGroup',
    'selectedSpecs',
    'open',
    'selectedFiles',
    'showToggle',
    'standalone'
  ],
  components: {
    SpecButton,
    SpecSubMenu,
    ProductDescription,
    TransitionHeight,
    DatePicker,
    MenuGroupHeader,
    OptionGroupHeader,
    OptionGroupDescription
  },
  mixins: [ProductOrderMixin],
  data() {
    return {
      showSub: [],
      showInfo: false
    }
  },
  computed: {
    note() {
      return this.selectedFiles[0].productSpecs.specs.find((spec) => {
        return spec.optionGroupName === 'opmerking'
      }).optionTitle
    },
    selectedFileNames() {
      let fileNames = []
      this.selectedFiles.forEach((file) => {
        fileNames.push(file.fileName)
      })
      return fileNames
    }
  },
  methods: {
    /*     commentText(comment) {
      return comment.length > 20 ? comment.slice(0, 20 - 3) + '...' : comment
    }, */
    hasSub(subOptions) {
      if (subOptions && Object.keys(subOptions).length) {
        return true
      } else {
        return false
      }
    },
    hideSub() {
      this.showSub = []
    },
    optionTitle(menu, optionGroupName, option) {
      /*    let optionTitle
      if (option.subOptions) {
        option.subOptions.forEach((subOption) => {
          if (
            this.optionSelectedCheck(
              menu,
              optionGroupName,
              subOption,
              this.selectedFiles
            )
          ) {
            optionTitle = subOption.title
          }
        })
      }
      return optionTitle ? optionTitle : option.title */
      return option.title
    },
    setNote(menu, optionGroupName, val) {
      // Find the optionGroup to get productionCategory and priceObjectKey
      const optionGroup = menu.optionGroups?.find(
        (og) => og.name === optionGroupName
      )

      const noteOption = {
        title: menu.title || '',
        optionGroupName: optionGroupName || '',
        optionName: val,
        optionTitle: val,
        priceKey: 'opmerking',
        productionCategory: optionGroup?.productionCategory || menu.title
      }

      // Add priceObjectKey if the optionGroup has it
      if (optionGroup?.priceObjectKey) {
        noteOption.priceObjectKey = optionGroup.priceObjectKey
      }

      // Add fileTypeRequired if the menu has it
      if (menu.fileTypeRequired) {
        noteOption.fileTypeRequired = menu.fileTypeRequired
      }

      this.setOption(noteOption, this.selectedFileNames)
    },

    setSpec(menu, optionGroupName, optionName, option) {
      this.showSub = []
      if (option.subOptions && Object.keys(option.subOptions).length) {
        this.showSub.push(optionName)
      } else {
        // Find the optionGroup to get productionCategory and priceObjectKey
        const optionGroup = menu.optionGroups?.find(
          (og) => og.name === optionGroupName
        )

        const selectedOption = {
          title: menu.title || '',
          optionGroupName: optionGroupName || '',
          optionName: optionName || '',
          optionTitle: option.title || '',
          productionTitle: option.productionTitle || option.title || '',
          priceKey: option.priceKey || '',
          priceValue: option.priceValue || '',
          productionCategory: optionGroup?.productionCategory || menu.title
        }

        // Add priceObjectKey if the optionGroup has it
        if (optionGroup?.priceObjectKey) {
          selectedOption.priceObjectKey = optionGroup.priceObjectKey
        }

        // Add fileTypeRequired if the menu has it
        if (menu.fileTypeRequired) {
          selectedOption.fileTypeRequired = menu.fileTypeRequired
        }

        this.setOption(selectedOption, this.selectedFileNames)
      }
    },
    toggleGroup() {
      if (this.showToggle) this.$emit('toggleMenu', this.open)
    }
  }
}
</script>

<style lang="scss" scoped>
.group-container {
  box-shadow: var(--default-shadow);
  border-radius: 25px;
}

.menu-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 15px 20px;
  row-gap: 15px;
  column-gap: 8px;

  li {
    flex-basis: 200px;
    /*   flex-grow: 0;
    flex-shrink: 0; */
    position: relative;
  }

  &.standalone {
    li {
      min-width: 198px;
      flex-shrink: 1;
      flex-basis: 256px;
      //flex-grow: 1;
    }
  }
}

.menu-block {
  &:last-of-type .menu-options {
    padding-bottom: 20px;
  }

  hr {
    border-bottom: 1px solid #b2b2b2;
    width: calc(100% - 40px);
    display: block;
    margin: 5px 25px;
  }
}

.comment {
  width: 100%;
  padding: 0 20px 15px;

  textarea {
    width: 100%;
    height: 120px;
  }
}

.menu-group-holder {
  // voorkomt dat de margin-bottom van het laatste kind buiten de kaart valt
  display: flow-root;

  &.full-height {
    display: flex;
    flex-direction: column;

    .menu-block {
      flex: 0;
      display: flex;
      flex-direction: column;
    }

    .comment {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;

      textarea {
        flex: 1;
        height: auto;
        min-height: 120px;
      }
    }
  }
}
</style>
